module.exports = __webpack_public_path__ + "static/media/SV.1f2e7466.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/SV.svg
// module id = 2267
// module chunks = 7